import { FontWeight } from 'lib/styles';
import { Text } from 'styles/themeColors';
import { currencySign } from 'utils/formatters';
import { COUNTRY_ISO } from './country';

const initialColumns = [
  {
    title: '#',
    field: 'orderId',
    headerStyle: { color: Text.primary, fontWeight: FontWeight.bold},
    cellStyle: { minWidth: '150px', width: '150px' },
    width: '150px'
  },
  {
    title: 'Status',
    field: 'status',
    headerStyle: { color: Text.primary, fontWeight: FontWeight.bold },
    width: '100px'
  },
  {
    title: 'Vendor',
    field: 'vendor',
    headerStyle: { color: Text.primary, fontWeight: FontWeight.bold },
    cellStyle: (cellValue, rowData) => {
      return cellValue === 'Multiple' ? { color: Text.placeholder } : {}
    },
    width: 'auto'
  },
  {
    title: 'Business Unit',
    field: 'businessUnit',
    headerStyle: { color: Text.primary, fontWeight: FontWeight.bold },
    cellStyle: (cellValue, rowData) => {
      return cellValue === 'Multiple' ? { color: Text.placeholder } : {}
    },
    width: 'auto'
  },
  {
    title: 'Warehouse',
    field: 'warehouse',
    headerStyle: { color: Text.primary, fontWeight: FontWeight.bold },
    cellStyle: (cellValue, rowData) => {
      return cellValue === 'Multiple' ? { color: Text.placeholder } : {}
    },
    width: 'auto'
  },
  {
    title: 'Delivery',
    field: 'deliveryType',
    headerStyle: { color: Text.primary, fontWeight: FontWeight.bold },
    width: 'auto'
  },
  {
    title: 'Country',
    field: 'countryName',
    headerStyle: { color: Text.primary, fontWeight: FontWeight.bold },
    width: 'auto'
  },
  {
    title: 'Customer',
    field: 'customerName',
    headerStyle: { color: Text.primary, fontWeight: FontWeight.bold },
    width: 'auto'
  },
  {
    title: 'Company',
    field: 'companyName',
    headerStyle: { color: Text.primary, fontWeight: FontWeight.bold },
    width: 'auto'
  },
  {
    title: 'Date',
    field: 'created',
    type: 'date',
    dateSetting: { locale: 'en-US' },
    headerStyle: { color: Text.primary, fontWeight: FontWeight.bold },
    width: 'auto',
    defaultSort: 'desc'
  },
  {
    title: 'Payment',
    field: 'paymentType',
    headerStyle: { color: Text.primary, fontWeight: FontWeight.bold },
    width: 'auto'
  },
  {
    title: 'Updated by',
    field: 'updatedBy',
    headerStyle: { color: Text.primary, fontWeight: FontWeight.bold },
    cellStyle: (cellValue, rowData) => {
      return cellValue === 'Multiple' ? { color: Text.placeholder } : {}
    },
    width: 'auto'
  },
  {
    title: 'Total amount',
    field: 'totalPriceWithTax',
    render: rowData => {
      rowData.totalPriceWithTax = Number(rowData.totalPriceWithTax).toFixed(2);
      const countryIso = rowData.country?.countryIso || COUNTRY_ISO.US;
      return currencySign(countryIso, rowData.totalPriceWithTax);
    },
    headerStyle: { color: Text.primary, flexDirection: 'row', fontWeight: FontWeight.bold },
    width: 'auto'
  }
];

export default initialColumns;
